export default "__VITE_ASSET__yejuAU1h__"